export const DEFAULT_ALERT_TIMOUT = 3000;
